export enum SearchVisualPref {
	ENABLED = 'search.visual.enabled',
}
